import { Injectable, inject } from "@angular/core";
import { MODULES } from "src/app/core/modules";
import { LicenseService } from "src/app/services/feature-access-control/license.service";
import { RegionService } from "src/app/services/feature-access-control/region.service";

@Injectable()
export class ModuleService {
  private readonly licenseService = inject(LicenseService);
  private readonly regionService = inject(RegionService);

  async canBeActivated(module: MODULES): Promise<boolean> {
    const [byLicense, byRegion] = await Promise.all([
      this.licenseService.canBeActivated(module),
      this.regionService.canBeActivated(module)
    ]);

    return byLicense && byRegion;
  }

  canBeActivatedSync(module: MODULES): boolean {
    return (
      this.licenseService.canBeActivatedSync(module) &&
      this.regionService.canBeActivatedSync(module)
    );
  }
}
